<template>
  <div>
    <router-btn :text="$t('servicesystem.common_objects.machine.change_owner_all_btn')" :icon="'mdi-swap-horizontal'"
      :color="'secondary'" :disabled="false" :outlined="true" :textbtn="textbtn" :large="large" :small="small"
      @Press="action">
    </router-btn>
    <TransferAllMachinesDialog :externaltrigger="dialogtrigger" :currentCustomerId="customerId">
    </TransferAllMachinesDialog>
  </div>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";
import TransferAllMachinesDialog from "@/components/Dialogs/TransferAllMachinesDialog.vue";

export default {
  name: "TransferAllMachinesBtn",
  props: ["large", "small", "textbtn"],
  components: {
    RouterBtn,
    TransferAllMachinesDialog,
  },

  data() {
    return {
      dialogtrigger: 1,
    };
  },

  created() { },

  mounted() { },

  methods: {
    action() {
      this.dialogtrigger++;
    },
  },

  computed: {
    customerId() {
      return this.$route.params.customerId;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
